import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { NoData } from '@saucelabs/ds-data-states';
import { Link } from '@saucelabs/ds-link';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

const { APP_STORAGE_LIFETIME_DAYS } = appStorageConstants;

type NoAppsUploadedProps = {
  uploadBox: React.ReactNode;
}

const NoAppsUploaded: React.FC<NoAppsUploadedProps> = ({ uploadBox }) => (
  <div
    className="flex justify-center text-center"
    data-qa="app-management-no-apps-uploaded"
  >
    <div className="flex-grow inline-block max-w-3xl text-high-emphasis">
      <NoData
        className="inline-flex mb-5"
        description="Upload an app to start testing."
        spacing="large"
        title="Your app repository is empty"
      />

      {uploadBox}

      <Typography
        className="pt-4 mt-4 border-0 border-t border-gray-200 border-solid"
        variant="heading-4"
      >
        Not seeing your apps?
      </Typography>
      <Typography
        className="mb-3"
        variant="body"
      >
        {`Please check your data center or re-upload your application. Uploads will be stored for ${APP_STORAGE_LIFETIME_DAYS} days.`}
      </Typography>
      <Typography variant="body">
        {'Learn about '}
        <Link
          isExternal
          target="_blank"
          to="https://docs.saucelabs.com/mobile-apps/supported-devices"
        >
          improved real device testing
        </Link>
      </Typography>
      <Typography variant="body">
        {'Have questions? '}
        <Link
          isExternal
          target="_blank"
          to="https://saucelabs.com/training-support"
        >
          Get support
        </Link>
      </Typography>
    </div>
  </div>
);

export default NoAppsUploaded;
